<template>
 <div id="eq-loader">
        <div class="eq-loader-div">
            <div class="eq-loading dual-loader mx-auto mb-5"></div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            progress: 0
        }
    },
    created(){
        let vm = this;
        var interval = setInterval(() => {
            if(vm.progress != 100){
                vm.progress = vm.progress + 30;
            }else{
                clearInterval(interval);
            }
        }, 100);
    },
    methods: {
        
    }
};
</script>
<style>
</style>
